import React from "react";
import { Breadcrumbs, styled, Typography } from "@mui/material";
import { NavLink } from "react-router";

const BreadcrumbsLink = styled(NavLink)(({ theme }) => ({
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "125%",
  color: theme.palette.neutral?.[700] || "#666", // fallback color if neutral not defined
  textDecoration: "none",
  [theme.breakpoints.down("md")]: {
    fontSize: "14px",
  },
  "&:hover": {
    color: theme.palette.neutral?.[800] || "#333",
    textDecoration: "none",
  },
}));
const BreadcrumbNavigation = ({ items }) => {
  return (
    <Breadcrumbs separator="›" sx={{ mb: { xs: 0, sm: 1, md: 2 } }}>
      <BreadcrumbsLink to="/" end>
        Home
      </BreadcrumbsLink>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return isLast ? (
          <Typography
            key={index}
            color="text.primary"
            sx={{
              fontWeight: 600,
              fontSize: { xs: "12px", sm: "14px", md: "16px" },
              textTransform: "capitalize",
              color: "var(--neutral-black)",
            }}
          >
            {item.label}
          </Typography>
        ) : (
          <BreadcrumbsLink key={index} to={item.path}>
            {item.label}
          </BreadcrumbsLink>
        );
      })}
    </Breadcrumbs>
  );
};

export default React.memo(BreadcrumbNavigation);
